var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-map-icon map-icon"},[_c('svg-icon',{staticClass:"a-map-icon__icon",attrs:{"original":"","name":("map-navigation/" + _vm.direction)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }